import { Anchor, Text } from '@mantine/core';
import {
  type BookingSurface,
  MEDLEY_TEAM_EMAIL,
  changeOrCancelText,
  inviteLeadText,
} from './inviteSentText';

/**
 * MED-1365: the "invite is on its way" line of a booking confirmation, with
 * the email in bold. See inviteSentText for the words. MED-1389: with no
 * email, the line says "your email". The public page passes none, because the
 * invite can go to the roster address, not the typed one.
 */
export function InviteOnItsWay({
  email,
  fallback,
}: {
  email?: string;
  fallback: boolean;
}) {
  return (
    <Text size="sm" c="dimmed" ta="center">
      {inviteLeadText(fallback)}
      {email ? (
        <Text span fw={600} c="dark">
          {email}
        </Text>
      ) : (
        'your email'
      )}
      .
    </Text>
  );
}

/**
 * MED-1365: how to change or cancel the booking (see changeOrCancelText).
 * The Medley team address is a mailto link.
 */
export function ChangeOrCancel({
  fallback,
  surface,
  contactEmail = MEDLEY_TEAM_EMAIL,
}: {
  fallback: boolean;
  surface: BookingSurface;
  /** MED-1365 QA round 6: the cohort's address, from the API. */
  contactEmail?: string;
}) {
  const [before, after] = changeOrCancelText(
    fallback,
    surface,
    contactEmail
  ).split(contactEmail);
  return (
    <Text size="sm" c="dimmed" ta="center">
      {before}
      {after !== undefined && (
        <>
          <Anchor href={`mailto:${contactEmail}`} size="sm">
            {contactEmail}
          </Anchor>
          {after}
        </>
      )}
    </Text>
  );
}
